import { memo } from 'react';

import { Button, ButtonVariant, Icon, Link, Modal, Typography, useModal } from '@/shared/ui';

import { govUaToastConfig } from '@/config/govUaToast';

import { trackGovUaModalOpen } from '@/loader/trackGovUaModalOpen';

import { ColorConfig } from '@/contexts/AntdConfigProvider/theme';

import './GovUaLogoStyles.scss';

interface GovUaToastButtonProps {
  toggleModal: () => void;
  onClick?: () => void;
  color?: Extract<ColorConfig, 'white' | 'black'>;
}

export const GovUaLogoButton = memo<GovUaToastButtonProps>(({ toggleModal, color = 'white' }) => (
  <Button
    aria-label="GOV.UA Державні сайти України"
    variant={ButtonVariant.GHOST}
    className="custom-gov-ua"
    onClick={(): void => {
      toggleModal();
      trackGovUaModalOpen();
    }}
  >
    <Icon name="gov-ua-logo" width={92} height={28} color={color} />
  </Button>
));

export const GovUaLogoModalContent = memo(() => (
  <div className="custom-gov-ua__links">
    {govUaToastConfig.map((configValue) => (
      <Link
        key={configValue.title}
        className="custom-gov-ua__link"
        to={configValue.ref}
        rel="noreferrer nofollow noopener"
      >
        <Typography as="span" variant="H4">
          {configValue.title}
        </Typography>
        <Icon name="arrow_forward" />
      </Link>
    ))}
  </div>
));

export const GovUaLogo = memo<Pick<GovUaToastButtonProps, 'color' | 'onClick'>>(({ onClick, color = 'white' }) => {
  const { isOpen, toggleModal } = useModal();

  const onToggleModal = (): void => {
    typeof onClick === 'function' && onClick();
    toggleModal();
  };

  return (
    <>
      <GovUaLogoButton color={color} toggleModal={onToggleModal} />
      <Modal title="Державні сайти України" open={isOpen} onCancel={onToggleModal}>
        <GovUaLogoModalContent />
      </Modal>
    </>
  );
});
